import React from "react";

const MatchDay = ({ item, dragProvided }) => {
    return (
        <div
            className="matches__teamcontainer"
            {...dragProvided.dragHandleProps}
            {...dragProvided.draggableProps}
            ref={dragProvided.innerRef}
        >
            <p className="matches__team">
                <span>{item.shortName}</span>

                {item?.index === 0 && (
                    <span className={`matches__identifier-Home`}>Home</span>
                )}

                {item?.index === 1 && (
                    <span className="matches__identifier-Away">Away</span>
                )}
            </p>
        </div>
    );
};

export default MatchDay;
